import React from 'react';
import PropTypes from 'prop-types';
import PageSelector from 'Components/PageSelector';
import classnames from 'classnames';
import Button from 'Components/Button';
import HollowButton from 'Components/Button/HollowButton';
import PrimaryButton from 'Components/Button/PrimaryButton';
import RightPointerIcon from 'Components/icons/right-pointer-icon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import moment from 'moment';
import './ImageWizardAccordian.scss';

const ImageWizardAccordian = ({
  id,
  headerText,
  docDate,
  isOpen,
  toggleAccordion,
  directionalText,
  leftLinkButtonText,
  leftLinkButtonAction,
  linkButtonText,
  secondaryButtonText,
  secondaryButtonAction,
  primaryButtonAction,
  primaryButtonText,
  showFooterLeft,
  hideToggleButton,
  headerActionMethod,
  contentIndex,
  headerButtonName,
  headerButtonStyle,
  pageSelected,
  pageSelectorStyle,
  pageList,
  canvasSelectedIndex,
  updatePageSelectionIndexMethod,
  updateParentSelectedPages,
  selectedPages,
  selectAllFlag,
  userSelectedImageOrder,
  footerText,
  fileSize,
  acquirerCode,
}) => {
  const headerClass = classnames('wizard-accordion__header', {
    'wizard-accordion__header--toggled': isOpen,
  });

  const toggleClass = classnames('wizard-accordion__toggler', {
    'wizard-accordion__toggler--expanded': isOpen,
    'wizard-accordion__toggler--collapsed': !isOpen,
  });

  const bodyClass = classnames('wizard-accordion__body', {
    'wizard-accordion__body--expanded': isOpen,
  });

  const footerClass = classnames('wizard-accordion__footer', {
    'wizard-accordion__footer--toggled': isOpen,
  });

  const headerButton = headerButtonName && <button type="button" onClick={() => headerActionMethod(id)} className="save-btn" style={headerButtonStyle}>{headerButtonName}</button>;
  const children = (
    <PageSelector
      id={id}
      pageList={pageList}
      selectedPages={selectedPages}
      updatePageSelectionIndex={updatePageSelectionIndexMethod}
      canvasSelectedIndex={canvasSelectedIndex}
      updateParentSelectedPages={updateParentSelectedPages}
      imageCheckBoxRequired
      selectAllButtonRequired={false}
      selectAllFlag={selectAllFlag}
      collatedPageSeq={true}
      userSelectedImageOrder={userSelectedImageOrder}
      acquirerCode ={acquirerCode}
    />
  );
  return (
    <article className="wizard-accordion__wrapper">
      <div style={{ display: 'inline-flex', border: '1px solid #c4c4c4' }}>
        <header
          role="button"
          tabIndex={0}
          className={headerClass}
          onClick={() => toggleAccordion(id)}
          onKeyDown={() => toggleAccordion(id)}
          id={id}
          style={{ width: 489, wordBreak: 'break-all' }}
        >
          {!hideToggleButton && <span className={toggleClass} />}
          <div className='heading_outer'>
          <h1 className="wizard-accordion__headline wizard-accordion__headline--header-space">{headerText}</h1>
          <h1 className="wizard-accordion__headline">
            {moment(new Date(docDate)).format('MM/DD/YYYY')}
          </h1>
          </div>
        </header>
        <header
          role="button"
          tabIndex={0}
          className={headerClass}
          id={id}
          style={{ width: 256 }}
        >
          <h1 className="wizard-accordion__headline" style={pageSelectorStyle}>
            {pageSelected}
          </h1>
          {headerButton}
        </header>
      </div>
      <div className={bodyClass}>
        <div className="wizard-accordion__content">
          {children}
        </div>
        {(linkButtonText || secondaryButtonText || primaryButtonText) && (
          <footer className="wizard-accordion__footer">
            <div className="wizard-accordion__footer-left">
              {
                (showFooterLeft && leftLinkButtonText.length > 0)
                && (
                  <Button
                    action={leftLinkButtonAction}
                    category="link-inline"
                  >
                    {leftLinkButtonText}
                  </Button>
                )
              }
            </div>
            <div className="wizard-accordion__footer-right">
              {
                directionalText.length > 0
                && (
                  <span className="wizard-accordion__footer-right-text">
                    {directionalText}
                    {' '}
                    <RightPointerIcon />
                  </span>
                )
              }
              {linkButtonText
                && (
                  <Button
                    action={toggleAccordion}
                  >
                    {linkButtonText}
                  </Button>
                )}
              {secondaryButtonText && (
                <HollowButton action={secondaryButtonAction}>
                  {' '}
                  {secondaryButtonText}
                  {' '}
                </HollowButton>
              )}
              {
                primaryButtonText
                && (
                  <PrimaryButton
                    action={primaryButtonAction}
                  >
                    {primaryButtonText}
                  </PrimaryButton>
                )
              }
            </div>
          </footer>
        )}


      </div>
      <footer
          tabIndex={0}
          className={footerClass}
          id={id}
        >
          <div className='wizard-accordion__footer--outer_space'>
            <h3 className="wizard-accordion__footerheadingline heading-space">File</h3>
            <InformationBubble  id={footerText} tooltipContent={footerText}>
              <h3 className="wizard-accordion__footerheadingline--footerline wizard-accordion__footerheadingline--wrap-content">{footerText}</h3>
            </InformationBubble>
          </div>
          <div className='wizard-accordion__footer--page-space'>
            <h3 className="wizard-accordion__footerheadingline">Size</h3>
            <h3 className="wizard-accordion__footerheadingline--footerline">{fileSize} MB</h3>
          </div>
          <div className='wizard-accordion__footer--page-space'>
            <h3 className="wizard-accordion__footerheadingline">Pages</h3>
            <h3 className="wizard-accordion__footerheadingline--footerline">{pageList.length}</h3>
          </div>
      </footer>
    </article>
  );
};

ImageWizardAccordian.propTypes = {
  directionalText: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  leftLinkButtonText: PropTypes.string,
  leftLinkButtonAction: PropTypes.func,
  linkButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  primaryButtonAction: PropTypes.func,
  primaryButtonText: PropTypes.string,
  id: PropTypes.number.isRequired,
  showFooterLeft: PropTypes.bool,
  hideToggleButton: PropTypes.bool,
  isAttachImage: PropTypes.bool,
  footerText: PropTypes.string,
  fileSize: PropTypes.number,
  docDate: PropTypes.string,
};

ImageWizardAccordian.defaultProps = {
  directionalText: '',
  leftLinkButtonText: '',
  leftLinkButtonAction: () => { },
  linkButtonText: '',
  secondaryButtonText: '',
  primaryButtonAction: () => { },
  primaryButtonText: '',
  showFooterLeft: false,
  hideToggleButton: false,
  isAttachImage: false,
  pageSelected: '0 Pages Selected',
  footerText: '',
  fileSize: 0,
  docDate: '',
};

export default ImageWizardAccordian;
